import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { api } from "../services/index";
import { connect } from "../recontext/store";
import Loading from "./Loading";
import ListTeam from "./ListTeam";
import { Typography } from "@material-ui/core";

const theme = new URL(window.location.href).searchParams.get("theme");
const IS_DARK_THEME = theme === "dark";

const styles = theme => ({
  container: {
    backgroundColor: IS_DARK_THEME ? "#333333" : "#eceff1",
    paddingTop: 24,
    paddingBottom: 24,
    margin: 0,
    width: "100%",
    height: "100%",
    minHeight: 600
  }
});

class ListTeams extends React.PureComponent {
  constructor(props) {
    super(props);
    this.getData = this.getData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      loading: true,
      filter: "All"
    };
  }

  componentDidMount() {
    this.getData();
  }

  async getData() {
    await api.getTeams();
    this.setState({
      loading: false
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    const { classes, teams, teamLikers, user } = this.props;
    const { loading, filter } = this.state;

    if (loading || !teams || teams.length === 0) return <Loading visible />;

    const myTeam = {};
    const pendingTeams = {};
    const promisingTeams = {};
    const otherTeams = Object.assign({}, teams);

    if (user && user.teamId && teams[user.teamId]) {
      myTeam[user.teamId] = teams[user.teamId];
      delete otherTeams[user.teamId];
      const likers =
        teamLikers && teamLikers[user.teamId] ? teamLikers[user.teamId] : [];
      likers.map(likerId => {
        if (teams[likerId].members.length === 1) {
          pendingTeams[likerId] = teams[likerId];
          delete otherTeams[likerId];
        }
      });
    }

    Object.keys(otherTeams).map(teamId => {
      if (otherTeams[teamId].members.length > 1) {
        promisingTeams[teamId] = otherTeams[teamId];
        delete otherTeams[teamId];
      }
    });

    const countOtherTeams = Object.keys(otherTeams).length;

    if (filter !== "All") {
      Object.keys(otherTeams).map(teamId => {
        if (
          (filter === "None" && !otherTeams[teamId].track) ||
          (filter !== "None" && otherTeams[teamId].track !== filter)
        )
          delete otherTeams[teamId];
      });
    }

    const countFilteredTeams = Object.keys(otherTeams).length;

    return (
      <Grid container spacing={24} className={classes.container}>
        {user && (
          <Grid item xs={12} md={12}>
            <Typography gutterBottom variant="headline" align="center">
              My Cool Team
            </Typography>
            <Divider />
            <ListTeam teams={myTeam} />
          </Grid>
        )}
        {user && (
          <Grid item xs={12} md={12}>
            <Typography gutterBottom variant="headline" align="center">
              Pending Team-up
            </Typography>
            <Divider />
            <ListTeam teams={pendingTeams} />
          </Grid>
        )}
        <Grid item xs={12} md={12}>
          <Typography gutterBottom variant="headline" align="center">
            Promising Teams
          </Typography>
          <Divider />
          <ListTeam teams={promisingTeams} />
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography gutterBottom variant="headline" align="center">
            FA Teams
          </Typography>
          <Typography gutterBottom variant="title" align="center">
            Filter by track:{" "}
            <Select
              value={filter}
              onChange={this.handleChange}
              inputProps={{
                name: "filter",
                id: "filter"
              }}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value={"BlockChain"}>
                Loyalty program with blockchain
              </MenuItem>
              <MenuItem value={"FinTech"}>Fun finance application</MenuItem>
              <MenuItem value={"BigData"}>Prediction with big data</MenuItem>
              <MenuItem value={"None"}>Haven't picked any track yet</MenuItem>
            </Select>{" "}
            ({countFilteredTeams}/{countOtherTeams})
          </Typography>

          <Divider />
          <ListTeam teams={otherTeams} />
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  teamLikers: state.teamLikers,
  teams: state.teams
});

export default connect(mapStateToProps)(withStyles(styles)(ListTeams));
